import { Components, Theme } from '@mui/material/styles';

export const loaderTheme: Components<Theme>['MuiCircularProgress'] = {
  // styleOverrides: {},
  // variants: [],
};
